import React, { useEffect, useState, useRef } from "react";
import logoImage from "../assest/images/logo-img.png"
import whiteLogoImage from "../assest/images/whitelogo.png";
import smallLogo from "../assest/myImages/logo_sm1.png";
import clickIcon from "../assest/images/clickIcon.png";
import closeIcon from "../assest/images/closeIcon.png";

import Ava from "../assest/myImages/Ava.png";

import { useSelector, useDispatch } from "react-redux";
import { setLogout, setLoading, setDarkMode, setLanguage } from "../redux/user/user.action"
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import ApiCall from "../common/ApiCall";
import ToastAlert from "../common/ToastAlert";
import CustomDropdown from "./CustomDropdown";
import helper, { generateSlug, getLangBySlug, getLinkNameByLang, getSlugByLang, getSlugNameByLang } from "../common/Helper";
import ContentLoader from 'react-content-loader'
import { setSearchHistory } from "../redux/global/global.action";
import IconDropdown from "./IconDropdown";
import { allHeaderLangs, languageOptions } from "../common/Config";
import LocationDropdown from "./LocationDropdown";


const Header = () => {
    const [isActive, setIsActive] = useState(false);
    const [menuVisible, setMenuVisible] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const user = useSelector((state) => state.user);
    const global = useSelector((state) => state.global);
    const isDark = user.isDarkMode;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isDarkMode, setIsDarkMode] = useState(() => {
        return isDark;
    });
    const location = useLocation()
    const [suggetionHistory, setSuggetionHistory] = useState([]);
    const searchHistory = global?.searchHistory
    const { lang } = useParams(); // from route like /:lang/...

    const locations = [
        'Ahmedabad', 'Rajkot', 'Junagadh'
    ];

    // const filteredLocations = locations.filter(location => location.toLowerCase().includes(searchQuery));

    // const [selectedLocation, setSelectedLocation] = useState("Location");
    let selectedLand = languageOptions.filter((e) => e.label == user?.language)
    const [selectedLanguage, setSelectedLanguage] = useState(selectedLand && selectedLand.length > 0 ? selectedLand[0] : languageOptions[0]);
    const [selectedCurrency, setSelectedCurrency] = useState("EUR");
    const [isScrolled, setIsScrolled] = useState(false);
    const [locationOptions, setLocationOptions] = useState([]);
    const [destinationSuggetions, setDestinationSuggetions] = useState([]);
    const [activitiesSuggetion, setActivitiesSuggetion] = useState([]);
    const [productsSuggetion, setProductsSuggetion] = useState([]);
    const [blogsSuggetion, setBlogsSuggetion] = useState([]);
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [hoveredOption, setHoveredOption] = useState(null);
    // const [hoveredSubOption, setHoveredSubOption] = useState(null);
    const dropdownRef = useRef(null);
    // const locationOptions = ["Portugal", "Vilamoura", "Croatia", "Spain"];
    // const languageOptions = ["Frns", "Ita", "Eng"];

    const currencyOptions = ["USD", "INR", "EUR", "POUND"];
    const [isTypeBoxVisible, setIsTypeBoxVisible] = useState(true);
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const userdropdownRef = useRef(null);
    const searchKeyRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const typingTimer = useRef(null);
    const slugField = getSlugNameByLang(user?.language)
    const userlang = getSlugByLang(user?.language);
    const slugLinkField = getLinkNameByLang(user?.language)
    const searchKeyRefMob = useRef(null);
    const dropdownRefMob = useRef(null);
    const selectedLangRef = useRef(selectedLanguage);


    const updateSearchHistory = (rec) => {
        let sh = searchHistory ? searchHistory : []
        let hist = [...sh]


        if (!hist.some(item => item.url === rec.url)) {

            if (hist.length >= 5) {
                hist.pop();
            }
            hist.unshift(rec);
            dispatch(setSearchHistory(hist));
        }

    }

    const handleCheckboxChange = () => {
        setIsDarkMode((prevMode) => !prevMode);
    };
    // const searchBoxRef = useRef(null);


    const logout = async () => {
        dispatch(setLoading(true))
        const logout = await ApiCall('post', 'logout', null, user?.token)
        if (logout) {
            dispatch(setLoading(false))
            if (logout.data?.success) {
                dispatch(setLogout())
                ToastAlert({ msg: logout.data.message, msgType: 'success' });
                navigate('/' + userlang + '/login')

            } else {
                dispatch(setLogout())
                navigate('/' + userlang + '/login')

            }
        } else {
            dispatch(setLoading(false))
            ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
        }
    }

    useEffect(() => {
        let selectedLand = languageOptions.filter((e) => e.label == user?.language)
        setSelectedLanguage(selectedLand && selectedLand.length > 0 ? selectedLand[0] : languageOptions[0])
    }, [user?.language]);

    useEffect(() => {

        allHeaderLangs.forEach(lang => document.body.classList.remove(lang));

        document.body.classList.add(user?.language);
    }, [user?.language]);

    useEffect(() => {
        if (isDarkMode) {
            document.body.classList.add("dark");
        } else {
            document.body.classList.remove("dark");
        }
        dispatch(setDarkMode(isDarkMode))
    }, [isDarkMode]);

    const openMenu = () => {
        setMenuVisible(true);
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
    };

    const closeMenu = () => {
        setMenuVisible(false);
        document.body.style.position = 'unset';
        document.body.style.width = 'auto';
    };



    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setIsSearchVisible(e?.target?.value?.trim()?.length >= 3);

    };

    // const handleSelectItem = (item) => {
    //     setSearchQuery(item);
    //     setIsSearchVisible(false);
    // };

    const handleClickXIcon = () => {
        setIsActive(false)
        setSearchQuery('');
        setIsSearchVisible(false);
    };


    const getDropdownList = async () => {
        setIsLoading(true)
        const getList = await ApiCall('get', 'dropdown-options')
        setIsLoading(false)
        if (getList) {
            if (getList?.data?.success) {
                setLocationOptions(getList.data.data.locations)
            }
        }
    }


    useEffect(() => {
        (async () => {
            await getDropdownList()
        })()
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        // Attach scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };


    }, []);

    // const onChangeLocation = (val) => {
    //     // setSelectedLocation(val)
    //     window.scrollTo(0, 0);
    //     navigate('/location/' + val.slug)
    // }

    const getSearchSuggetions = async (search) => {
        setIsSearchLoading(true)
        var lang = getSlugByLang(user?.language);
        let data = {}
        data.search = search
        data.lang = lang

        const recordList = await ApiCall('post', 'search-suggetions', data)
        setIsSearchLoading(false)
        if (recordList) {
            if (recordList?.data?.success) {


                setDestinationSuggetions(recordList.data.data.destinations)
                setActivitiesSuggetion(recordList.data.data.activities);
                setProductsSuggetion(recordList.data.data.products)
                setBlogsSuggetion(recordList.data.data.blogs)

            }
        }
    };

    // const handleKeyUp = async (e) => {
    //     const value = e.target.value;
    //     if (value?.trim()?.length === 0) {
    //         setDestinationSuggetions([])
    //         setActivitiesSuggetion([])
    //         setProductsSuggetion([])
    //         // setSearchValue('');
    //     }
    //     if (value?.trim()?.length >= 3) {
    //         await getSearchSuggetions(value)
    //     }
    //     // setSearchValue(value);
    // };




    const handleKeyUp = async (e) => {

        if (!isActive) {
            setIsSearchLoading(false);
            return false
        }

        const value = e.target.value;
        clearTimeout(typingTimer.current); // Clear previous timer

        if (value.trim().length === 0) {
            setDestinationSuggetions([])
            setActivitiesSuggetion([])
            setProductsSuggetion([])
            setBlogsSuggetion([])

            // setSearchValue('');
        }
        setIsSearchLoading(false);
        if (value.length >= 3) {
            setIsSearchLoading(true);
            typingTimer.current = setTimeout(() => {
                getSearchSuggetions(value);
            }, 500); // Call function only after 0.5s of no typing
        }
        // setSearchValue(value);
    };

    const onClickDestination = (destination, parent, slug) => {
        setDropdownOpen(false);
        // let slug = generateSlug(destination)
        setIsSearchVisible(false);
        setIsActive(false);
        setSearchQuery('')
        setDestinationSuggetions([])
        setActivitiesSuggetion([])
        setProductsSuggetion([])
        setBlogsSuggetion([])
        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/search?location_name=' + slug

        let dta = {
            label: destination,
            // url: '/search?location_name=' + slug,
            url: url,
            sublabel: parent
        }
        updateSearchHistory(dta)
        navigate(url)
    }

    const onClickActivity = (id, name, activity) => {
        console.log(id, name);

        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/search?categories=' + id
        setDropdownOpen(false);
        // let slug = generateSlug(activity)
        setIsSearchVisible(false);
        setIsActive(false);
        setSearchQuery('')
        setDestinationSuggetions([])
        setActivitiesSuggetion([])
        setProductsSuggetion([])
        let dta = {
            label: name,
            // url: '/search?categories=' + id,
            url: url,
            sublabel: null
        }
        updateSearchHistory(dta)
        navigate(url)
    }

    const onClickProduct = (name, sublabel, slug) => {
        console.log(name, sublabel, slug);

        setDropdownOpen(false);
        setIsActive(false);
        setIsSearchVisible(false)
        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/tour/' + slug

        let dta = {
            label: name,
            // url: `/tour/${slug}`,
            url: url,
            sublabel: sublabel
        }
        updateSearchHistory(dta)
        // navigate(`/tour/${slug}`)
        navigate(url)

    }

    const onClickBlog = (name, slug) => {
        setDropdownOpen(false);
        setIsActive(false);
        setIsSearchVisible(false)
        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/blog/article/' + slug

        let dta = {
            label: name,
            // url: '/blog/article/' + slug,
            url: url,
            sublabel: null
        }
        updateSearchHistory(dta)
        // navigate('/blog/article/' + slug)
        navigate(url)

    }

    const toggleDropdown = () => {
        setDropdownOpen((prev) => !prev);
    };


    useEffect(() => {
        let checkInterval;

        // Function to check if the div is rendered
        const checkTypeBoxPresence = () => {
            const typeBoxElement = document.querySelector(".typeBox");

            if (typeBoxElement) {
                // If typeBox is found, clear the interval and start observing visibility
                clearInterval(checkInterval);
                observeTypeBox(typeBoxElement);
            } else {
                // setSearchQuery('')
                setIsTypeBoxVisible(false); // typeBox is not present
                // setIsSearchVisible(false)
            }
        };

        // Function to observe typeBox visibility
        const observeTypeBox = (typeBoxElement) => {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        setIsTypeBoxVisible(entry.isIntersecting);
                        if (!entry.isIntersecting) {
                            // setSearchQuery('')
                            setIsSearchVisible(false)
                            setIsActive(false)
                        }
                    });
                },
                { threshold: 0.1 }
            );

            observer.observe(typeBoxElement);

            return () => {
                observer.disconnect();
            };
        };

        // Start checking every 100ms
        checkInterval = setInterval(checkTypeBoxPresence, 100);

        // Cleanup interval on unmount
        return () => clearInterval(checkInterval);
    }, [location.pathname]);


    const handleClickOutside = (event) => {
        if (userdropdownRef.current && !userdropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    const onClickSuggetion = (link) => {
        setDropdownOpen(false);
        setIsActive(false);
        setIsSearchVisible(false)
        navigate(link)

    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [])


    useEffect(() => {
        const handleClickOutsideSearchBox = (event) => {
            if (
                dropdownRef.current && !dropdownRef.current.contains(event.target) &&
                searchKeyRef.current && !searchKeyRef.current.contains(event.target) &&
                dropdownRefMob.current && !dropdownRefMob.current.contains(event.target) &&
                searchKeyRefMob.current && !searchKeyRefMob.current.contains(event.target)
            ) {

                setIsActive(false);
                setIsSearchVisible(false)
            }
        };

        document.addEventListener("mousedown", handleClickOutsideSearchBox);

        return () => {
            document.removeEventListener("mousedown", handleClickOutsideSearchBox);
        };
    }, []);


    useEffect(() => {
        setSuggetionHistory(searchHistory)
    }, [searchHistory]);


    const hasResetRef = useRef(false);
    const googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
            {
                pageLanguage: "en",
                autoDisplay: false,
            },
            "google_translate_element"
        );
    };
    let lastGTInitTime = 0;
    const reinitGoogleTranslate = () => {

        const now = Date.now();
        if (now - lastGTInitTime < 3000) {
            console.warn('Skipping GT reinit to prevent conflict');
            return;
        }
        lastGTInitTime = now;
        console.log('test 123');

        // ✅ Fully clean up toolbar + iframe + selects
        const container = document.getElementById("google_translate_element");
        if (container) {
            container.innerHTML = "";
        } else {
            const d = document.createElement("div");
            d.id = 'google_translate_element'
            d.style = "display:none"
            document.body.appendChild(d);
        }

        // ✅ Remove injected Google Translate elements
        const googEls = document.querySelectorAll('[class^="goog"], iframe, link[href*="translate.googleapis.com"]');
        googEls.forEach(el => el.remove());

        // ✅ Remove previous script
        const oldScript = document.getElementById("google-translate-script");
        if (oldScript) oldScript.remove();

        // ✅ Remove global state
        delete window.google;
        for (const k in window) {
            if (k.startsWith("googleTranslateElementInit")) delete window[k];
        }

        // ✅ Use a new callback name
        const uniqueCallback = `googleTranslateElementInit_${Date.now()}`;

        // window[uniqueCallback] = () => {
        //     new window.google.translate.TranslateElement(
        //         {
        //             pageLanguage: "en",
        //             autoDisplay: false,
        //         },
        //         "google_translate_element"
        //     );
        // };
        window[uniqueCallback] = () => {
            try {
                new window.google.translate.TranslateElement(
                    {
                        pageLanguage: "en",
                        autoDisplay: false,
                    },
                    "google_translate_element"
                );
            } catch (err) {
                console.error('GT init failed:', err);
            }
        };

        console.log('creating script');


        const script = document.createElement("script");
        script.id = "google-translate-script";
        script.src = `//translate.google.com/translate_a/element.js?cb=${uniqueCallback}`;
        document.body.appendChild(script);

        // Optional: cleanup callback reference after load
        setTimeout(() => {
            delete window[uniqueCallback];
        }, 10000);
    };




    useEffect(() => {
        const addTranslateScript = () => {


            if (!window.google?.translate) {
                var addScript = document.createElement("script");
                addScript.setAttribute(
                    "src",
                    "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
                );
                document.body.appendChild(addScript);
                window.googleTranslateElementInit = googleTranslateElementInit;
            }
        };
        addTranslateScript();



        const syncDropdown = setInterval(() => {
            const googleSelect = document.querySelector(".goog-te-combo");

            if (!googleSelect) return;

            if (!googleSelect.value && !hasResetRef.current) {
                hasResetRef.current = true;

                // ✅ Don't reset to "en" — let Google Translate just stop translating
                console.log('selectedLanguage 591', selectedLanguage)
                const pathParts = location.pathname.split("/");
                console.log('pathParts', pathParts);

                let routeVal = languageOptions.find((e) => e.value == pathParts[1]);
                console.log('routeVal', routeVal);

                if (selectedLangRef.current && selectedLangRef.current.value !== "en") {
                    dispatch(setLanguage(selectedLangRef.current.label));
                    setSelectedLanguage(selectedLangRef.current);
                } else {
                    dispatch(setLanguage("English"));
                    setSelectedLanguage(languageOptions[0]);
                }

                // ✅ Optional: if URL had a language prefix, reset it
                if (pathParts[1] && (pathParts[1] === "othr" || pathParts[1] === "en")) {
                    pathParts[1] = "en";
                    const newPath = pathParts.join("/") + location.search + location.hash;
                    navigate(newPath, { replace: true });
                }
            }


            // Reset guard if user switches again (optional)
            if (googleSelect.value && googleSelect.value !== "en") {
                hasResetRef.current = false;
            }
        }, 1000);


        return () => {
            clearInterval(syncDropdown);
        };

    }, []);

    useEffect(() => {
        const select = document.querySelector('.goog-te-combo');
        console.log('sel val', select?.value);
        console.log('selectedLanguage.value', selectedLanguage.value);


        if (select && selectedLanguage.value != "en") {
            console.log('comes', select.value);
            let lng = lang ? (lang == 'othr' ? 'othr' : lang) : selectedLanguage.value;

            select.value = lng == 'pt' ? 'pt-PT' : lng; // target language (English)
            // select.dispatchEvent(new Event('change'));
            select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // }, [selectedLanguage.value, document.querySelector('.goog-te-combo')])
    }, [selectedLanguage.value])



    let switchingLang = false;

    const onSelectLang = (e) => {
        console.log('onSelectLang', e);
        selectedLangRef.current = e;
        if (switchingLang) return;
        switchingLang = true;

        setTimeout(() => switchingLang = false, 1500); // avoid race conditions

        setSelectedLanguage(e);
        dispatch(setLanguage(e.label));

        const select = document.querySelector('.goog-te-combo');
        const el = document.getElementById("google_translate_element");
        console.log('select', select);
        console.log('window.google?.translate', window.google?.translate);
        console.log('el', el);




        // If Google Translate is missing, reinit (don't reload!)
        if (!select || !window.google?.translate || !el) {
            reinitGoogleTranslate();

            // Retry language switch after delay (wait for reinit)
            setTimeout(() => {
                const newSelect = document.querySelector('.goog-te-combo');
                if (newSelect) {
                    changeLanguage(e);
                }
            }, 2000); // Adjust delay as needed
        } else {
            changeLanguage(e);
        }
    };


    let isChangingLang = false;

    const changeLanguage = (e) => {
        if (isChangingLang) return; // 🚫 Prevent spam clicks
        isChangingLang = true;

        const select = document.querySelector('.goog-te-combo');
        const slug = getSlugByLang(e.label);
        const pathParts = location.pathname.split("/");

        console.log('location.pathname', location.pathname);
        console.log('pathParts', pathParts);



        // if (pathParts[1] && pathParts[1].length === 2) {
        //     pathParts[1] = slug;
        // } else {
        //     pathParts.splice(1, 0, slug);
        // }
        if (pathParts.length === 2 && pathParts[1]) {
            pathParts[1] = slug;
        }
        // Case 2: path starts with lang code
        else if (pathParts[1] && pathParts[1].length === 2) {
            pathParts[1] = slug;
        }
        // Case 3: no lang yet, insert
        else {
            pathParts.splice(1, 0, slug);
        }



        const newPath = pathParts.join("/") + location.search + location.hash;

        // ✅ CLEARING TRANSLATION
        if (e.value === 'en') {
            document.cookie = `googtrans=; path=/; domain=${window.location.hostname}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
            document.cookie = `googtrans=/en/en; path=/; domain=${window.location.hostname}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
            sessionStorage?.removeItem('googtrans');

            document.querySelectorAll('[class^="goog"], .goog-te-banner-frame, iframe').forEach(el => {
                if (el.src?.includes('translate') || el.className.includes('goog')) {
                    el.remove();
                }
            });

            if (select) {
                try {
                    select.value = '';
                    // select.dispatchEvent(new Event('change'));
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (err) {
                    console.warn('GT clear error:', err);
                }

                setTimeout(() => {
                    try {
                        select.value = 'en';
                        // select.dispatchEvent(new Event('change'));
                        select.dispatchEvent(new Event('change', { bubbles: true }));
                    } catch (err) {
                        console.warn('GT reapply error:', err);
                    }

                    navigate(newPath, { replace: true });

                    setTimeout(() => {
                        isChangingLang = false;
                        window.location.reload();
                    }, 150);
                }, 150);
            } else {
                navigate(newPath, { replace: true });
                setTimeout(() => {
                    isChangingLang = false;
                    window.location.reload();
                }, 150);
            }

            return;
        }

        // 🌐 NON-ENGLISH
        if (select) {
            try {
                if (e.label === "Other") {
                    select.value = 'es';
                    // select.dispatchEvent(new Event('change'));
                    select.dispatchEvent(new Event('change', { bubbles: true }));

                    setTimeout(() => {
                        select.value = 'en';
                        // select.dispatchEvent(new Event('change'));
                        select.dispatchEvent(new Event('change', { bubbles: true }));

                        document.querySelectorAll('.skiptranslate').forEach(el => {
                            el.style.setProperty('display', 'block', 'important');
                        });
                        document.querySelectorAll('.goog-te-banner-frame').forEach(el => {
                            el.style.display = 'block';
                        });

                        isChangingLang = false;
                    }, 500);
                } else {
                    try {
                        select.value = e.value === 'pt' ? 'pt-PT' : e.value;
                        // select.dispatchEvent(new Event('change'));
                        select.dispatchEvent(new Event('change', { bubbles: true }));
                        isChangingLang = false;
                    } catch (err) {
                        console.warn('GT clear error:', err);
                    }

                }
            } catch (err) {
                console.error('GT switch error:', err);
                isChangingLang = false;
            }
        }

        console.log('nwpath', newPath);


        navigate(newPath, { replace: true });
    };





    return (

        <header className={isScrolled ? 'show ' : ''}>

            <div className="header-part">
                <div className="container">
                    <div className="header-box desktopView">
                        <div className="logoBox">
                            <div className="logoImg">
                                <Link className="comLogo" to={'/' + userlang}><img src={logoImage} alt="logo-img" /></Link>
                                <Link className="whitelogo" to={'/' + userlang}><img src={whiteLogoImage} alt="whitelogo" /></Link>
                            </div>

                            {isLoading ?
                                <ContentLoader
                                    backgroundColor="#e0e0d9"
                                    foregroundColor="#d6d6d0"
                                    height="30" width="150" viewBox="12 10 150 30" >
                                    <rect x="25" y="15" rx="4" ry="5" width="150" height="30" />
                                </ContentLoader> :
                                <div
                                    className="locationBox"
                                    onMouseEnter={() => setShowDropdown(true)}
                                    onMouseLeave={() => {
                                        setShowDropdown(false);
                                        setHoveredOption(null);
                                    }}
                                >
                                    {/* Location label */}

                                    <a href="javascript:void(0)" className={showDropdown ? "active" : ""}>
                                        <span>Location</span> <i className="fa-solid fa-chevron-down"></i>
                                    </a>

                                    {/* Dropdown menu */}
                                    {showDropdown && (
                                        <ul className="dropDownLoc">
                                            {locationOptions.map((item, index) => (
                                                <li
                                                    key={index}
                                                    className={item?.children?.length > 0 ? "newdropOpen" : ""}
                                                    onMouseEnter={() => setHoveredOption(index)}
                                                    onMouseLeave={() => setHoveredOption(null)}
                                                >
                                                    <Link to={(userlang ? '/' + userlang : '') + `/location${item?.[slugLinkField]}`}>
                                                        <span>{item?.name}</span>
                                                        {item?.children?.length > 0 && (
                                                            <i className="fa-solid fa-chevron-right"></i>
                                                        )}
                                                    </Link>
                                                    {hoveredOption === index && item?.children?.length > 0 && (
                                                        <ul className="innerNewDrop" style={{ marginLeft: "unset" }}>
                                                            {item.children.map((subOption, subIndex) => (
                                                                <li key={subIndex}>
                                                                    <Link to={(userlang ? '/' + userlang : '') + `/location${subOption?.[slugLinkField]}`}>
                                                                        {subOption?.name}
                                                                    </Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            }
                        </div>
                        <div className="menuBox">
                            <div className="navBar mobileMenu">
                                <ul>
                                    {/* <li><Link to={(userlang ? '/' + userlang : '') + '/about-us'}>About</Link></li>
                                    <li><Link to={(userlang ? '/' + userlang : '') + '/terms-and-conditions'}>Terms and Conditions</Link></li>
                                    <li><Link to={(userlang ? '/' + userlang : '') + '/contact-us'}>Contacts</Link></li> */}

                                    <li><a href="javascript:void(0)" onClick={

                                        () => {
                                            document.body.style.position = '';
                                            closeMenu()
                                            setTimeout(() => {
                                                navigate('/' + userlang + '/about-us');
                                            }, 0); // delay by one "tick" of the event loop
                                        }
                                    }>About</a></li>
                                    <li><a href="javascript:void(0)" onClick={

                                        () => {
                                            document.body.style.position = '';
                                            closeMenu()
                                            setTimeout(() => {
                                                navigate('/' + userlang + '/terms-and-conditions');
                                            }, 0); // delay by one "tick" of the event loop
                                        }
                                    }>Terms and Conditions</a></li>
                                    <li><a href="javascript:void(0)" onClick={

                                        () => {
                                            document.body.style.position = '';
                                            closeMenu()
                                            setTimeout(() => {
                                                navigate('/' + userlang + '/contact-us');
                                            }, 0); // delay by one "tick" of the event loop
                                        }
                                    }>Contact us</a></li>
                                </ul>
                            </div>
                            <div className={`searchBox ${isActive ? 'active' : ''} ${!isTypeBoxVisible ? 'visible' : ''}`} ref={dropdownRef}>
                                <a className="iconS" href="javascript:void(0)" onClick={() => {
                                    setIsActive(true)
                                    document.getElementById("headerSearchInput").focus();

                                }}><i className="bi bi-search"></i></a>
                                <input
                                    className="clickList"
                                    id="headerSearchInput"
                                    value={searchQuery}
                                    onChange={handleSearch}
                                    onKeyUp={handleKeyUp}
                                    onFocus={() => {
                                        suggetionHistory &&
                                            suggetionHistory?.length > 0 &&
                                            setIsSearchVisible(true)
                                        setIsTypeBoxVisible(false)
                                    }

                                    }
                                    type="text"
                                    autoComplete="off"
                                    name="headersearch"
                                    placeholder="Search"
                                />
                                {/* {isSearchVisible && filteredLocations.length > 0 && (
                                    <div className="search-key">
                                        <ul>
                                            {filteredLocations.map((location, index) => (
                                                <li key={index} onClick={() => handleSelectItem(location)}>
                                                    <a href="javascript:void(0)">
                                                        <i className="bi bi-geo-alt-fill"></i> {location}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )} */}
                                <a className="iconX" href="javascript:void(0)" onClick={() => handleClickXIcon()}><i className="bi bi-x"></i></a>
                            </div>
                            <div className="dropLangBox">
                                <div className="selectDrop">
                                    <div className="languageBox">
                                        {/* <CustomDropdown
                                            options={languageOptions}
                                            selectedOption={selectedLanguage}
                                            onSelect={setSelectedLanguage}
                                            icon="fa-solid fa-globe"
                                            label="Language"
                                        /> */}
                                        <IconDropdown
                                            options={languageOptions.filter((e) => e?.value != selectedLanguage?.value)}
                                            selectedOption={selectedLanguage}
                                            onSelect={onSelectLang}
                                            label="Language"
                                        />
                                    </div>
                                    <div className="currencyBox">
                                        <CustomDropdown
                                            // options={currencyOptions}
                                            options={currencyOptions.filter((e) => e != selectedCurrency)}
                                            selectedOption={selectedCurrency}
                                            onSelect={() => { return false }}
                                            icon="fa-solid fa-wallet"
                                            label="Currency"
                                            className="currencyDrop"
                                        />
                                    </div>
                                </div>
                                {
                                    user.token &&
                                    <div className="header-fav-icon">
                                        <Link to={'/' + userlang + "/profile/favourites"} className={location.pathname === '/' + userlang + '/profile/favourites' ? 'active' : ''}>
                                            <i className="bi bi-heart"></i>
                                            Favorites
                                        </Link>
                                    </div>
                                }
                                <div className="themeMode">
                                    <div className="roundBox">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input darkMode-switch"
                                                type="checkbox"
                                                role="switch"
                                                id="flexSwitchCheckDefault"
                                                checked={isDarkMode}
                                                onChange={handleCheckboxChange}

                                            />
                                        </div>
                                    </div>
                                </div>
                                {
                                    user.token ?


                                        <div className="supplier" ref={userdropdownRef}>
                                            <div className="userIconBox">
                                                <div className="userNameBox">

                                                    <h6>{user?.userDetails?.first_name} {user?.userDetails?.last_name}</h6>
                                                </div>
                                                <div className="userImg">
                                                    <a
                                                        className="userClick"
                                                        href="javascript:void(0)"
                                                        onClick={toggleDropdown}
                                                    >
                                                        {/* <img src={Ava} alt="user-icon" /> */}
                                                        <img
                                                            src={helper.S3Url + '/' + helper.profileImageDir + '/' + user?.userDetails?.profile_picture}
                                                            alt="noprofile"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = Ava
                                                            }}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            {isDropdownOpen && (
                                                <div className="userAc">
                                                    <ul>
                                                        <li>
                                                            <a href="javascript:void(0)" onClick={() => navigate('/' + userlang + '/profile')}>My Profile</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0)" onClick={() => logout()}>Log Out</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                        :
                                        <div className="btnBox">
                                            <button className="btn common-btn btnRegister"
                                                // onClick={() => navigate('/' + userlang + '/signup')}
                                                onClick={

                                                    () => {
                                                        document.body.style.position = '';
                                                        closeMenu()
                                                        setTimeout(() => {
                                                            navigate('/' + userlang + '/signup');
                                                        }, 0); // delay by one "tick" of the event loop
                                                    }
                                                }
                                            >Register <i className="fa-solid fa-chevron-right"></i></button>
                                            <button className="btn common-btn btnGold"
                                                // onClick={() => navigate('/' + userlang + '/login')}
                                                onClick={

                                                    () => {
                                                        document.body.style.position = '';
                                                        closeMenu()
                                                        setTimeout(() => {
                                                            navigate('/' + userlang + '/login');
                                                        }, 0); // delay by one "tick" of the event loop
                                                    }
                                                }
                                            >Login <i className="fa-solid fa-chevron-right"></i></button>
                                        </div>
                                }
                                {/* <div className="btnBox">
                                    {
                                        user.token ?
                                            <>
                                                <button className="btn common-btn btnRegister" onClick={() => navigate('/profile')}>Profile <i className="fa-solid fa-chevron-right"></i></button>
                                                <button className="btn common-btn btnGold" onClick={() => logout()}>Logout <i className="fa-solid fa-chevron-right"></i></button>
                                            </>
                                            :
                                            <>
                                                <button className="btn common-btn btnRegister" onClick={() => navigate('/signup')}>Register <i className="fa-solid fa-chevron-right"></i></button>
                                                <button className="btn common-btn btnGold" onClick={() => navigate('/login')}>Login <i className="fa-solid fa-chevron-right"></i></button>
                                            </>
                                    }

                                </div> */}
                            </div>
                            <div className={`search-key ${(!isSearchVisible || isTypeBoxVisible || !isActive) ? "d-none" : ""}`} ref={searchKeyRef}>
                                {
                                    isSearchLoading &&
                                    <div className={"preloader"} style={{ position: "absolute" }}>
                                        <div className="preloader-icon"></div>
                                    </div>
                                }
                                {
                                    suggetionHistory &&
                                    suggetionHistory?.length > 0 &&
                                    !isSearchLoading &&
                                    productsSuggetion?.length === 0 &&
                                    blogsSuggetion?.length === 0 &&
                                    activitiesSuggetion?.length === 0 &&
                                    destinationSuggetions?.length === 0 &&
                                    suggetionHistory?.length > 0 &&
                                    // searchValue == null &&
                                    searchQuery?.trim()?.length < 3 &&

                                    <>

                                        <ul>
                                            <h6 className="search-title">
                                                <i className="fa-solid fa-magnifying-glass"></i> Recent searches

                                            </h6>
                                            {
                                                suggetionHistory.map((his, index) => {
                                                    return (
                                                        <li key={index} className='suggetionRecord'>
                                                            {/* <Link to={his?.url}> */}
                                                            <a href="javascript:void(0)" onClick={() => onClickSuggetion(his?.url)}>
                                                                {his.label}
                                                                {
                                                                    his?.sublabel &&
                                                                    <span>{his?.sublabel}</span>
                                                                }
                                                            </a>
                                                            {/* </Link> */}
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </>
                                }
                                {
                                    searchQuery?.trim()?.length >= 3 && productsSuggetion.length === 0 && activitiesSuggetion.length === 0 && destinationSuggetions.length === 0 && blogsSuggetion?.length === 0 &&

                                    <ul>
                                        <li>
                                            <span href="javascript:void(0)">{isSearchLoading ? 'Searching...' : 'No results found'}</span>
                                        </li>
                                    </ul>
                                }
                                {
                                    destinationSuggetions.length > 0 &&
                                    <ul>

                                        <h6 className="search-title"><i className="fa-solid fa-location-dot"></i>Destinations</h6>
                                        {
                                            destinationSuggetions.map((destination, index) => {
                                                return (
                                                    <li key={index}>
                                                        <a href="javascript:void(0)" onClick={() => onClickDestination(destination.name, destination?.parent_name, destination?.[slugField])}>{destination.name}
                                                            {
                                                                destination?.parent_name &&
                                                                <span>{destination?.parent_name}</span>
                                                            }
                                                        </a>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                }

                                <ul>
                                    {
                                        (productsSuggetion.length > 0 || activitiesSuggetion.length) > 0 &&
                                        <h6 className="search-title"><i className="fa-solid fa-bolt"></i>Аctivities</h6>
                                    }

                                    {
                                        activitiesSuggetion.map((activity, index) => {
                                            return (
                                                <li key={index}>
                                                    <a href="javascript:void(0)" onClick={() => onClickActivity(activity.id, activity.name, activity?.[slugField])}>{activity.name}
                                                        {/* <span>{activity?.parent_name}</span> */}
                                                    </a>
                                                </li>
                                            )
                                        })
                                    }
                                    {
                                        productsSuggetion.map((product, index) => {
                                            const productLocation = product?.location ? JSON.parse(product.location) : null;
                                            const spacedValues = productLocation ? Object.values(productLocation).join(', ') : '';
                                            return (
                                                <li key={index}>
                                                    <a href="javascript:void(0)" onClick={() => onClickProduct(product.title, spacedValues, product?.[slugField])}>{product.title}
                                                        {
                                                            product?.location &&
                                                            <span>{spacedValues}</span>
                                                        }
                                                    </a>
                                                </li>
                                            )
                                        })
                                    }

                                </ul>
                                {
                                    blogsSuggetion.length > 0 &&
                                    <ul>

                                        <h6 className="search-title"><i className="fa-solid fa-newspaper"></i>Blogs</h6>
                                        {
                                            blogsSuggetion.map((blog, index) => {
                                                return (
                                                    <li key={index} className='suggetionRecord'>
                                                        <a href="javascript:void(0)" onClick={() => onClickBlog(blog.name, blog?.[slugField])}>{blog.name}
                                                        </a>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                }
                            </div>
                        </div>
                        <div className="hamburger">
                            <a className="click-menu" href="javascript:void(0)" onClick={openMenu}><img src={clickIcon} alt="clickIcon" /></a>
                            <a className="cancel-menu" href="javascript:void(0)" onClick={closeMenu}><img src={closeIcon} alt="closeIcon" /></a>
                        </div>
                    </div>
                    <div className="header-box mobileView">
                        <div className="logoBox">
                            <div className="logoImg">
                                <Link className={`comLogo ${!isActive ? '' : 'd-none'}`} to="/"><img src={logoImage} alt="logo-img" /></Link>
                                <Link className={`whitelogo ${!isActive ? '' : 'd-none'}`} to="/"><img src={whiteLogoImage} alt="whitelogo" /></Link>
                                <Link className={`smalllogo ${isActive ? '' : 'd-none'} `} to="/"><img src={smallLogo} alt="whitelogo" /></Link>

                            </div>
                            <div className="mobile_search_input">
                                <div className={`searchBox ${isActive ? 'active' : ''} ${!isTypeBoxVisible ? 'visible' : ''}`} ref={dropdownRefMob}>
                                    <a className="iconS" href="javascript:void(0)" onClick={() => {
                                        setIsActive(true)
                                        document.getElementById("headerSearchInput").focus();

                                    }}><i className="bi bi-search"></i></a>
                                    <input
                                        className="clickList"
                                        id="headerSearchInput"
                                        value={searchQuery}
                                        onChange={handleSearch}
                                        onKeyUp={handleKeyUp}
                                        onFocus={() => {
                                            suggetionHistory &&
                                                suggetionHistory?.length > 0 &&
                                                setIsSearchVisible(true)
                                            setIsTypeBoxVisible(false)
                                        }

                                        }
                                        type="text"
                                        autoComplete="off"
                                        name="headersearch"
                                        placeholder="Search"
                                    />
                                    {/* {isSearchVisible && filteredLocations.length > 0 && (
                                        <div className="search-key">
                                            <ul>
                                                {filteredLocations.map((location, index) => (
                                                    <li key={index} onClick={() => handleSelectItem(location)}>
                                                        <a href="javascript:void(0)">
                                                            <i className="bi bi-geo-alt-fill"></i> {location}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )} */}
                                    <a className="iconX" href="javascript:void(0)" onClick={() => handleClickXIcon()}><i className="bi bi-x"></i></a>
                                </div>
                                <div className={`search-key ${(!isSearchVisible || isTypeBoxVisible || !isActive) ? "d-none" : ""}`} ref={searchKeyRefMob}>
                                    {
                                        isSearchLoading &&
                                        <div className={"preloader"} style={{ position: "absolute" }}>
                                            <div className="preloader-icon"></div>
                                        </div>
                                    }
                                    {
                                        suggetionHistory &&
                                        suggetionHistory?.length > 0 &&
                                        !isSearchLoading &&
                                        productsSuggetion?.length === 0 &&
                                        blogsSuggetion?.length === 0 &&
                                        activitiesSuggetion?.length === 0 &&
                                        destinationSuggetions?.length === 0 &&
                                        suggetionHistory?.length > 0 &&
                                        // searchValue == null &&
                                        searchQuery?.trim()?.length < 3 &&

                                        <>

                                            <ul>
                                                <h6 className="search-title">
                                                    <i className="fa-solid fa-magnifying-glass"></i> Recent searches

                                                </h6>
                                                {
                                                    suggetionHistory.map((his, index) => {
                                                        return (
                                                            <li key={index} className='suggetionRecord'>
                                                                {/* <Link to={his?.url}> */}
                                                                <a href="javascript:void(0)" onClick={() => onClickSuggetion(his?.url)}>
                                                                    {his.label}
                                                                    {
                                                                        his?.sublabel &&
                                                                        <span>{his?.sublabel}</span>
                                                                    }
                                                                </a>
                                                                {/* </Link> */}
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </>
                                    }
                                    {
                                        searchQuery?.trim()?.length >= 3 && productsSuggetion.length === 0 && activitiesSuggetion.length === 0 && destinationSuggetions.length === 0 && blogsSuggetion?.length === 0 &&

                                        <ul>
                                            <li>
                                                <span href="javascript:void(0)">{isSearchLoading ? 'Searching...' : 'No results found'}</span>
                                            </li>
                                        </ul>
                                    }
                                    {
                                        destinationSuggetions.length > 0 &&
                                        <ul>

                                            <h6 className="search-title"><i className="fa-solid fa-location-dot"></i>Destinations</h6>
                                            {
                                                destinationSuggetions.map((destination, index) => {
                                                    return (
                                                        <li key={index}>
                                                            <a href="javascript:void(0)" onClick={() => onClickDestination(destination.name, destination?.parent_name, destination?.[slugField])}>{destination.name}
                                                                {
                                                                    destination?.parent_name &&
                                                                    <span>{destination?.parent_name}</span>
                                                                }
                                                            </a>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    }

                                    <ul>
                                        {
                                            (productsSuggetion.length > 0 || activitiesSuggetion.length) > 0 &&
                                            <h6 className="search-title"><i className="fa-solid fa-bolt"></i>Аctivities</h6>
                                        }

                                        {
                                            activitiesSuggetion.map((activity, index) => {
                                                return (
                                                    <li key={index}>
                                                        <a href="javascript:void(0)" onClick={() => onClickActivity(activity.id, activity.name, activity?.[slugField])}>{activity.name}
                                                            {/* <span>{activity?.parent_name}</span> */}
                                                        </a>
                                                    </li>
                                                )
                                            })
                                        }
                                        {
                                            productsSuggetion.map((product, index) => {
                                                const productLocation = product?.location ? JSON.parse(product.location) : null;
                                                const spacedValues = productLocation ? Object.values(productLocation).join(', ') : '';
                                                return (
                                                    <li key={index}>
                                                        <a href="javascript:void(0)" onClick={() => onClickProduct(product.title, spacedValues, product?.[slugField])}>{product.title}
                                                            {
                                                                product?.location &&
                                                                <span>{spacedValues}</span>
                                                            }
                                                        </a>
                                                    </li>
                                                )
                                            })
                                        }

                                    </ul>
                                    {
                                        blogsSuggetion.length > 0 &&
                                        <ul>

                                            <h6 className="search-title"><i className="fa-solid fa-newspaper"></i>Blogs</h6>
                                            {
                                                blogsSuggetion.map((blog, index) => {
                                                    return (
                                                        <li key={index} className='suggetionRecord'>
                                                            <a href="javascript:void(0)" onClick={() => onClickBlog(blog.name, blog?.[slugField])}>{blog.name}
                                                            </a>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    }
                                </div>
                                <div className="hamburger">
                                    <a className="click-menu" href="javascript:void(0)" onClick={openMenu}><img src={clickIcon} alt="clickIcon" /></a>
                                    <a className={`cancel-menu ${menuVisible ? 'show' : ''}`} onClick={closeMenu} href="javascript:void(0)"><img src={closeIcon} alt="closeIcon" /></a>
                                </div>
                            </div>
                        </div>
                        <div className={`menuBox ${menuVisible ? 'show' : ''}`}>
                            {/* <div className="searchBox2">
                                <input className="main" type="search" placeholder="Поиск" />
                                <i className="fa-solid fa-location-dot"></i>
                                <div className="innerSecrch">
                                    <div className="srcBox">
                                        <input type="search" placeholder="Seacrh" />
                                        <i className="fa-solid fa-magnifying-glass"></i>
                                    </div>
                                </div>
                            </div> */}
                            <div className="dropLangBox">
                                <div className="selectDrop">
                                    <div className="languageBox">
                                        {/* <CustomDropdown
                                            options={languageOptions}
                                            selectedOption={selectedLanguage}
                                            onSelect={setSelectedLanguage}
                                            icon="fa-solid fa-globe"
                                            label="Language"
                                        /> */}
                                        <IconDropdown
                                            options={languageOptions}
                                            selectedOption={selectedLanguage}
                                            onSelect={onSelectLang}
                                            label="Language"
                                        />
                                    </div>
                                    <div className="currencyBox">
                                        {/* <CustomDropdown
                                            options={currencyOptions}
                                            selectedOption={selectedCurrency}
                                            onSelect={setSelectedCurrency}
                                            icon="fa-solid fa-wallet"
                                            label="Currency"
                                        /> */}
                                        <CustomDropdown
                                            // options={currencyOptions}
                                            options={currencyOptions.filter((e) => e != selectedCurrency)}
                                            selectedOption={selectedCurrency}
                                            onSelect={() => { return false }}
                                            icon="fa-solid fa-wallet"
                                            label="Currency"
                                            className="currencyDrop"
                                        />
                                    </div>

                                    <div className="themeMode">
                                        <div className="roundBox">
                                            <div className="form-check form-switch">
                                                <input className="form-check-input darkMode-switch"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="flexSwitchCheckDefault"
                                                    checked={isDarkMode}
                                                    onChange={handleCheckboxChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="btnBox">
                                    {
                                        user.token ?
                                            <>
                                                <button className="btn common-btn btnRegister" onClick={

                                                    () => {
                                                        document.body.style.position = '';
                                                        closeMenu()
                                                        setTimeout(() => {
                                                            navigate('/' + userlang + '/profile');
                                                        }, 0); // delay by one "tick" of the event loop
                                                    }
                                                }>Profile <i className="fa-solid fa-chevron-right"></i></button>
                                                <button className="btn common-btn btnGold"
                                                    onClick={() => logout()}
                                                >Logout <i className="fa-solid fa-chevron-right"></i></button>
                                            </>
                                            :
                                            <>
                                                <button className="btn common-btn btnRegister"
                                                    // onClick={() => navigate('/' + userlang + '/signup')}
                                                    onClick={

                                                        () => {
                                                            document.body.style.position = '';
                                                            closeMenu()
                                                            setTimeout(() => {
                                                                navigate('/' + userlang + '/signup');
                                                            }, 0); // delay by one "tick" of the event loop
                                                        }
                                                    }
                                                >Register <i className="fa-solid fa-chevron-right"></i></button>
                                                <button className="btn common-btn btnGold"
                                                    // onClick={() => navigate('/' + userlang + '/login')}
                                                    onClick={

                                                        () => {
                                                            document.body.style.position = '';
                                                            closeMenu()
                                                            setTimeout(() => {
                                                                navigate('/' + userlang + '/login');
                                                            }, 0); // delay by one "tick" of the event loop
                                                        }
                                                    }

                                                >Login <i className="fa-solid fa-chevron-right"></i></button>
                                            </>
                                    }

                                </div>
                            </div>
                            <div className="navBar mobileMenu">
                                <ul>
                                    {/* <li><Link to={(userlang ? '/' + userlang : '') + '/about-us'}>About</Link></li>
                                    <li><Link to={(userlang ? '/' + userlang : '') + '/terms-and-conditions'}>Terms and Conditions</Link></li>
                                    <li><Link to={(userlang ? '/' + userlang : '') + '/contact-us'}>Contacts</Link></li> */}

                                    <li><a href="javascript:void(0)" onClick={

                                        () => {
                                            document.body.style.position = '';
                                            closeMenu()
                                            setTimeout(() => {
                                                navigate('/' + userlang + '/about-us');
                                            }, 0); // delay by one "tick" of the event loop
                                        }
                                    }>About</a></li>
                                    <li><a href="javascript:void(0)" onClick={

                                        () => {
                                            document.body.style.position = '';
                                            closeMenu()
                                            setTimeout(() => {
                                                navigate('/' + userlang + '/terms-and-conditions');
                                            }, 0); // delay by one "tick" of the event loop
                                        }
                                    }>Terms</a></li>
                                    <li><a href="javascript:void(0)" onClick={

                                        () => {
                                            document.body.style.position = '';
                                            closeMenu()
                                            setTimeout(() => {
                                                navigate('/' + userlang + '/contact-us');
                                            }, 0); // delay by one "tick" of the event loop
                                        }
                                    }>Contact us</a></li>
                                </ul>
                            </div>

                            <LocationDropdown
                                locationOptions={locationOptions}
                                userlang={userlang}
                                slugLinkField={slugLinkField}
                                closeMenu={closeMenu}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* <GoogleTranslate /> */}
            <div id="google_translate_element" style={{ display: 'none' }}></div>
        </header>
    )
}
export default Header